import React, { useState } from 'react';
import { ILenderContactData } from '../../../types/contacts/ILenderContact';
import { Card } from 'ui-toolkit';
import { ContactsPageTemplate } from './subComponents/ContactsPageTemplate';
import { LenderOrderContactsTable } from '../../../components/order/contacts/lenderOrderContacts/LenderOrderContactsTable';
import { IFetchDataState } from '../../../store/IFetchDataState';
import { AddLenderOrderContactForm } from '../../../components/order/contacts/lenderOrderContacts/AddLenderOrderContactForm';
import { IContactsPageProps } from './ClientContactsPage';
import { EditLenderOrderContactForm } from '../../../components/order/contacts/lenderOrderContacts/EditLenderOrderContactForm';
import { ILenderUserData } from '../../../types/lenders/ILenderUser';
import { useListContactFunctionsQuery } from '../../../API/contacts/ContactFunctionsApi';
import { Show } from '../../../components/shared/Show';

interface ILenderContactsPageProps extends IContactsPageProps {
  lenderContacts: ILenderContactData[];
  preExistingLenderContacts: IFetchDataState<string, ILenderUserData[]>;
  onRequestListOfPreExistingLenderContacts: () => void;
  onAddNewContact: (data: ILenderContactData) => void;
  onUpdateContact: (data: ILenderContactData) => void;
}

export const LenderContactsPage: React.FC<ILenderContactsPageProps> = ({
  loading,
  lenderContacts,
  preExistingLenderContacts,
  onRequestListOfPreExistingLenderContacts,
  addFetchStatus,
  addFetchError,
  onAddNewContact,
  onResetAddContact,
  onUpdateContact,
  updateFetchStatus,
  updateFetchError,
  onResetUpdateContact,
  onDeleteContact,
  deleteFetchError,
  deleteFetchStatus,
  onResetDeleteContact,
}) => {
  const [showAddContactForm, setShowAddContactForm] = useState(false);
  const [editContact, setEditContact] = useState<ILenderContactData | null>(null);
  const { data: contactFunctions = [] } = useListContactFunctionsQuery();

  const onCancelAddContactForm = () => {
    setShowAddContactForm(false);
    onResetAddContact();
  };

  const onCancelEditContactForm = () => {
    setEditContact(null);
    onResetUpdateContact();
  };

  const handleAddContactForm = () => {
    setShowAddContactForm(true);
    onRequestListOfPreExistingLenderContacts();
  };

  const onAddContact = (contactId: string) => {
    const existingContact = lenderContacts.find((c) => c.lenderUser && c.lenderUser.id === contactId);
    if (existingContact) {
      setShowAddContactForm(false);
      setEditContact(existingContact);
    }
  };

  return (
    <Card>
      <ContactsPageTemplate
        hintText={'Points of contact for the lender'}
        header={'Lender Contacts'}
        addContact={handleAddContactForm}
      >
        <Show when={contactFunctions.length !== 0}>
          <LenderOrderContactsTable
            data={lenderContacts}
            loading={loading}
            onEditContact={setEditContact}
            contactFunctions={contactFunctions}
          />
        </Show>
      </ContactsPageTemplate>
      {showAddContactForm && (
        <AddLenderOrderContactForm
          preExistingLenderContacts={preExistingLenderContacts}
          onSubmit={onAddNewContact}
          onCancel={onCancelAddContactForm}
          addFetchStatus={addFetchStatus}
          addFetchError={addFetchError}
          onAddContact={onAddContact}
        />
      )}
      {editContact && (
        <EditLenderOrderContactForm
          initialData={editContact}
          onSubmit={onUpdateContact}
          onCancel={onCancelEditContactForm}
          onDelete={onDeleteContact}
          updateFetchStatus={updateFetchStatus}
          updateFetchError={updateFetchError}
          deleteFetchStatus={deleteFetchStatus}
          deleteFetchError={deleteFetchError}
          onResetDeleteContact={onResetDeleteContact}
        />
      )}
    </Card>
  );
};
